<template>
    <div>
        <ur-form-box 
            :column="options.column" 
            :labelSize="labelSize" 
            :labelDisplay="labelDisplay" 
            :labelAlign="options.labelAlign" 
            :expandMessage="options.expandLabel"
            :small="sizeSmall"
            :medium="sizeMedium"

            @expandToggle="expandToggle"
        >
            <ur-form-item v-for="(item, index) in mainItems"
                class="ur-form-item__element"
                :key="index"
                :label="item.label" 
                :required="item.required"
                :noLabel="labelSize === '0px'? true : false"
                :colSpan="item.colSpan > options.column ? options.column : item.colSpan"
                :noHeight="item.noHeight"
            >
                <template v-if="item.type === 'text'">
                    {{formData[item.value]}}
                </template>
                <ur-text-field v-else-if="item.type === 'textfield'"
                    :ref="'main-'+item.value+'-'+index"
                    v-model="formData[item.value]" 
                    :placeholder="item.options.placeholder"
                    :mask="item.options.mask"
                    :rules="item.options.rules"
                    :counter="item.options.counter"
                    :clearable="item.options.clearable"

                    :small="sizeSmall"
                    :medium="sizeMedium"
                    :lazy="options.lazy"
                    :disabled="options.disabled || item.disabled"
                    @input="updateValue" 
                />
                <ur-text-area v-else-if="item.type === 'textarea'"
                    :ref="'main-'+item.value+'-'+index"
                    v-model="formData[item.value]" 
                    :placeholder="item.options.placeholder"
                    :rows="item.options.rows"
                    :resize="item.options.resize"
                    :rules="item.options.rules"
                    :counter="item.options.counter"

                    :small="sizeSmall"
                    :medium="sizeMedium"
                    :lazy="options.lazy"
                    :disabled="options.disabled || item.disabled"
                    @input="updateValue" 
                />
                <ur-dropdown v-else-if="item.type === 'dropdown-single'"
                    :ref="'main-'+item.value+'-'+index"
                    v-model="formData[item.value]" 
                    :items="item.options.items"
                    :itemText="item.options.itemText"
                    :itemValue="item.options.itemValue"
                    :itemWidth="item.options.itemWidth"
                    :rules="item.options.rules"

                    :small="sizeSmall"
                    :medium="sizeMedium"
                    :lazy="options.lazy"
                    :disabled="options.disabled || item.disabled"
                    @input="updateValue" 
                />
                <ur-multi-dropdown v-else-if="item.type === 'dropdown-multi'"
                    :ref="'main-'+item.value+'-'+index"
                    v-model="formData[item.value]" 
                    :items="item.options.items"
                    :itemText="item.options.itemText"
                    :itemValue="item.options.itemValue"
                    :itemWidth="item.options.itemWidth"
                    :rules="item.options.rules"
                    :applyBtn="item.options.applyBtn"
                    :selectAll="item.options.selectAll"

                    :small="sizeSmall"
                    :medium="sizeMedium"
                    :lazy="options.lazy"
                    :disabled="options.disabled || item.disabled"
                    @input="updateValue" 
                />
                <ur-radio-wrapper v-else-if="item.type === 'radio'" 
                    :ref="'main-'+item.value+'-'+index"
                    v-model="formData[item.value]" 
                    :items="item.options.items"
                    :itemText="item.options.itemText"
                    :itemValue="item.options.itemValue"
                    :rules="item.options.rules"

                    :small="sizeSmall"
                    :medium="sizeMedium"
                    :lazy="options.lazy"
                    :disabled="options.disabled || item.disabled"
                    @input="updateValue" 
                />
                <ur-checkbox-wrapper v-else-if="item.type === 'checkbox'" 
                    :ref="'main-'+item.value+'-'+index"
                    v-model="formData[item.value]" 
                    :group="item.value"
                    :rules="item.options.rules"

                    :small="sizeSmall"
                    :medium="sizeMedium"
                    :lazy="options.lazy"
                    :disabled="options.disabled || item.disabled"
                    @input="updateValue"
                >
                    <ur-checkbox v-for="checkItem in item.options.items" 
                        :key="checkItem[item.options.itemValue]" 
                        :value="checkItem[item.options.itemValue]" 
                        :group="item.value"
                    >
                        {{checkItem[item.options.itemText]}}
                    </ur-checkbox>
                </ur-checkbox-wrapper>
                <ur-date-picker v-else-if="item.type === 'date'" 
                    :ref="'main-'+item.value+'-'+index"
                    v-model="formData[item.value]" 
                    :inputType="item.options.inputType"
                    :modelType="item.options.modelType"
                    :init="item.options.init"
                    :minDate="item.options.minDate"
                    :maxDate="item.options.maxDate"
                    :noPlaceholder="item.options.noPlaceholder"
                    :todayLabel="item.options.todayLabel"
                    :confirmLabel="item.options.confirmLabel"
                    :rules="item.options.rules"

                    :small="sizeSmall"
                    :medium="sizeMedium"
                    :lazy="options.lazy"
                    :disabled="options.disabled || item.disabled"
                    @input="updateValue"
                />
                <ur-range-picker v-else-if="item.type === 'date-range'" 
                    :ref="'main-'+item.value+'-'+index"
                    v-model="formData[item.value]" 
                    :inputType="item.options.inputType"
                    :modelType="item.options.modelType"
                    :init="item.options.init"
                    :minDate="item.options.minDate"
                    :maxDate="item.options.maxDate"
                    :noPlaceholder="item.options.noPlaceholder"
                    :cancelLabel="item.options.cancelLabel"
                    :confirmLabel="item.options.confirmLabel"
                    :oneInputMode="item.options.oneInputMode"
                    :rules="item.options.rules"

                    :small="sizeSmall"
                    :medium="sizeMedium"
                    :lazy="options.lazy"
                    :disabled="options.disabled || item.disabled"
                    @input="updateValue"
                />
                <ur-week-picker v-else-if="item.type === 'week'" 
                    :ref="'main-'+item.value+'-'+index"
                    v-model="formData[item.value]" 
                    :noPlaceholder="item.options.noPlaceholder"
                    :confirmLabel="item.options.confirmLabel"
                    :rules="item.options.rules"

                    :small="sizeSmall"
                    :medium="sizeMedium"
                    :lazy="options.lazy"
                    :disabled="options.disabled || item.disabled"
                    @input="updateValue" 
                />
                <ur-quarter-picker v-else-if="item.type === 'quarter'" 
                    :ref="'main-'+item.value+'-'+index"
                    v-model="formData[item.value]" 
                    :noPlaceholder="item.options.noPlaceholder"
                    :confirmLabel="item.options.confirmLabel"
                    :rules="item.options.rules"

                    :small="sizeSmall"
                    :medium="sizeMedium"
                    :lazy="options.lazy"
                    :disabled="options.disabled || item.disabled"
                    @input="updateValue" 
                />
                <ur-month-picker v-else-if="item.type === 'month'" 
                    :ref="'main-'+item.value+'-'+index"
                    v-model="formData[item.value]" 
                    :noPlaceholder="item.options.noPlaceholder"
                    :confirmLabel="item.options.confirmLabel"
                    :rules="item.options.rules"

                    :small="sizeSmall"
                    :medium="sizeMedium"
                    :lazy="options.lazy"
                    :disabled="options.disabled || item.disabled"
                    @input="updateValue"
                />
                <ur-year-picker v-else-if="item.type === 'year'" 
                    :ref="'main-'+item.value+'-'+index"
                    v-model="formData[item.value]" 
                    :noPlaceholder="item.options.noPlaceholder"
                    :confirmLabel="item.options.confirmLabel"
                    :rules="item.options.rules"

                    :small="sizeSmall"
                    :medium="sizeMedium"
                    :lazy="options.lazy"
                    :disabled="options.disabled || item.disabled"
                    @input="updateValue"
                />
                <ur-date-time-picker v-else-if="item.type === 'datetime'" 
                    :ref="'main-'+item.value+'-'+index"
                    v-model="formData[item.value]" 
                    :inputType="item.options.inputType"
                    :modelType="item.options.modelType"
                    :init="item.options.init"
                    :minDate="item.options.minDate"
                    :maxDate="item.options.maxDate"
                    :noPlaceholder="item.options.noPlaceholder"
                    :todayLabel="item.options.todayLabel"
                    :confirmLabel="item.options.confirmLabel"
                    :timepickerMode="item.options.timepickerMode ? 'dropdown' : 'false'"
                    :term="item.options.term"
                    :containMrdm="item.options.containMrdm"
                    :rules="item.options.rules"

                    :small="sizeSmall"
                    :medium="sizeMedium"
                    :lazy="options.lazy"
                    :disabled="options.disabled || item.disabled"
                    @input="updateValue"
                />
                <ur-date-time-range-picker v-else-if="item.type === 'datetime-range'" 
                    :ref="'main-'+item.value+'-'+index"
                    v-model="formData[item.value]" 
                    :init="item.options.init"
                    :minDate="item.options.minDate"
                    :maxDate="item.options.maxDate"
                    :noPlaceholder="item.options.noPlaceholder"
                    :cancelLabel="item.options.cancelLabel"
                    :confirmLabel="item.options.confirmLabel"
                    :timepickerMode="item.options.timepickerMode ? 'dropdown' : 'false'"
                    :term="item.options.term"
                    :containMrdm="item.options.containMrdm"
                    :oneInputMode="item.options.oneInputMode"
                    :rules="item.options.rules"

                    :small="sizeSmall"
                    :medium="sizeMedium"
                    :lazy="options.lazy"
                    :disabled="options.disabled || item.disabled"
                    @input="updateValue"
                />
            </ur-form-item>

            <template #expandable-zone>

                <ur-form-item v-for="(item, index) in expandedItems"
                    class="ur-form-item__element"
                    :key="index"
                    :label="item.label" 
                    :required="item.required"
                    :noLabel="labelSize === '0px'? true : false"
                    :colSpan="item.colSpan > options.column ? options.column : item.colSpan"
                    :noHeight="item.noHeight"
                >
                    <template v-if="item.type === 'text'">
                        {{formData[item.value]}}
                    </template>
                    <ur-text-field v-else-if="item.type === 'textfield'"
                        :ref="'expand-'+item.value+'-'+index"
                        v-model="formData[item.value]" 
                        :placeholder="item.options.placeholder"
                        :mask="item.options.mask"
                        :rules="item.options.rules"
                        :counter="item.options.counter"
                        :clearable="item.options.clearable"

                        :small="sizeSmall"
                        :medium="sizeMedium"
                        :lazy="options.lazy"
                        :disabled="options.disabled || item.disabled"
                        @input="updateValue" 
                    />
                    <ur-text-area v-else-if="item.type === 'textarea'"
                        :ref="'expand-'+item.value+'-'+index"
                        v-model="formData[item.value]" 
                        :placeholder="item.options.placeholder"
                        :rows="item.options.rows"
                        :resize="item.options.resize"
                        :rules="item.options.rules"
                        :counter="item.options.counter"

                        :small="sizeSmall"
                        :medium="sizeMedium"
                        :lazy="options.lazy"
                        :disabled="options.disabled || item.disabled"
                        @input="updateValue" 
                    />
                    <ur-dropdown v-else-if="item.type === 'dropdown-single'"
                        :ref="'expand-'+item.value+'-'+index"
                        v-model="formData[item.value]" 
                        :items="item.options.items"
                        :itemText="item.options.itemText"
                        :itemValue="item.options.itemValue"
                        :itemWidth="item.options.itemWidth"
                        :rules="item.options.rules"

                        :small="sizeSmall"
                        :medium="sizeMedium"
                        :lazy="options.lazy"
                        :disabled="options.disabled || item.disabled"
                        @input="updateValue" 
                    />
                    <ur-multi-dropdown v-else-if="item.type === 'dropdown-multi'"
                        :ref="'expand-'+item.value+'-'+index"
                        v-model="formData[item.value]" 
                        :items="item.options.items"
                        :itemText="item.options.itemText"
                        :itemValue="item.options.itemValue"
                        :itemWidth="item.options.itemWidth"
                        :rules="item.options.rules"
                        :applyBtn="item.options.applyBtn"
                        :selectAll="item.options.selectAll"

                        :small="sizeSmall"
                        :medium="sizeMedium"
                        :lazy="options.lazy"
                        :disabled="options.disabled || item.disabled"
                        @input="updateValue" 
                    />
                    <ur-radio-wrapper v-else-if="item.type === 'radio'" 
                        :ref="'expand-'+item.value+'-'+index"
                        v-model="formData[item.value]" 
                        :items="item.options.items"
                        :itemText="item.options.itemText"
                        :itemValue="item.options.itemValue"
                        :rules="item.options.rules"

                        :small="sizeSmall"
                        :medium="sizeMedium"
                        :lazy="options.lazy"
                        :disabled="options.disabled || item.disabled"
                        @input="updateValue" 
                    />
                    <ur-checkbox-wrapper v-else-if="item.type === 'checkbox'" 
                        :ref="'expand-'+item.value+'-'+index"
                        v-model="formData[item.value]" 
                        :group="item.value"
                        :rules="item.options.rules"

                        :small="sizeSmall"
                        :medium="sizeMedium"
                        :lazy="options.lazy"
                        :disabled="options.disabled || item.disabled"
                        @input="updateValue"
                    >
                        <ur-checkbox v-for="checkItem in item.options.items" 
                            :key="checkItem[item.options.itemValue]" 
                            :value="checkItem[item.options.itemValue]" 
                            :group="item.value"
                        >
                            {{checkItem[item.options.itemText]}}
                        </ur-checkbox>
                    </ur-checkbox-wrapper>
                    <ur-date-picker v-else-if="item.type === 'date'" 
                        :ref="'expand-'+item.value+'-'+index"
                        v-model="formData[item.value]" 
                        :inputType="item.options.inputType"
                        :modelType="item.options.modelType"
                        :init="item.options.init"
                        :minDate="item.options.minDate"
                        :maxDate="item.options.maxDate"
                        :noPlaceholder="item.options.noPlaceholder"
                        :todayLabel="item.options.todayLabel"
                        :confirmLabel="item.options.confirmLabel"
                        :rules="item.options.rules"

                        :small="sizeSmall"
                        :medium="sizeMedium"
                        :lazy="options.lazy"
                        :disabled="options.disabled || item.disabled"
                        @input="updateValue"
                    />
                    <ur-range-picker v-else-if="item.type === 'date-range'" 
                        :ref="'expand-'+item.value+'-'+index"
                        v-model="formData[item.value]" 
                        :inputType="item.options.inputType"
                        :modelType="item.options.modelType"
                        :init="item.options.init"
                        :minDate="item.options.minDate"
                        :maxDate="item.options.maxDate"
                        :noPlaceholder="item.options.noPlaceholder"
                        :cancelLabel="item.options.cancelLabel"
                        :confirmLabel="item.options.confirmLabel"
                        :oneInputMode="item.options.oneInputMode"
                        :rules="item.options.rules"

                        :small="sizeSmall"
                        :medium="sizeMedium"
                        :lazy="options.lazy"
                        :disabled="options.disabled || item.disabled"
                        @input="updateValue"
                    />
                    <ur-week-picker v-else-if="item.type === 'week'" 
                        :ref="'expand-'+item.value+'-'+index"
                        v-model="formData[item.value]" 
                        :noPlaceholder="item.options.noPlaceholder"
                        :confirmLabel="item.options.confirmLabel"
                        :rules="item.options.rules"

                        :small="sizeSmall"
                        :medium="sizeMedium"
                        :lazy="options.lazy"
                        :disabled="options.disabled || item.disabled"
                        @input="updateValue" 
                    />
                    <ur-quarter-picker v-else-if="item.type === 'quarter'" 
                        :ref="'expand-'+item.value+'-'+index"
                        v-model="formData[item.value]" 
                        :noPlaceholder="item.options.noPlaceholder"
                        :confirmLabel="item.options.confirmLabel"
                        :rules="item.options.rules"

                        :small="sizeSmall"
                        :medium="sizeMedium"
                        :lazy="options.lazy"
                        :disabled="options.disabled || item.disabled"
                        @input="updateValue" 
                    />
                    <ur-month-picker v-else-if="item.type === 'month'" 
                        :ref="'expand-'+item.value+'-'+index"
                        v-model="formData[item.value]" 
                        :noPlaceholder="item.options.noPlaceholder"
                        :confirmLabel="item.options.confirmLabel"
                        :rules="item.options.rules"

                        :small="sizeSmall"
                        :medium="sizeMedium"
                        :lazy="options.lazy"
                        :disabled="options.disabled || item.disabled"
                        @input="updateValue"
                    />
                    <ur-year-picker v-else-if="item.type === 'year'" 
                        :ref="'expand-'+item.value+'-'+index"
                        v-model="formData[item.value]" 
                        :noPlaceholder="item.options.noPlaceholder"
                        :confirmLabel="item.options.confirmLabel"
                        :rules="item.options.rules"

                        :small="sizeSmall"
                        :medium="sizeMedium"
                        :lazy="options.lazy"
                        :disabled="options.disabled || item.disabled"
                        @input="updateValue"
                    />
                    <ur-date-time-picker v-else-if="item.type === 'datetime'" 
                        :ref="'expand-'+item.value+'-'+index"
                        v-model="formData[item.value]" 
                        :inputType="item.options.inputType"
                        :modelType="item.options.modelType"
                        :init="item.options.init"
                        :minDate="item.options.minDate"
                        :maxDate="item.options.maxDate"
                        :noPlaceholder="item.options.noPlaceholder"
                        :todayLabel="item.options.todayLabel"
                        :confirmLabel="item.options.confirmLabel"
                        :timepickerMode="item.options.timepickerMode ? 'dropdown' : 'false'"
                        :term="item.options.term"
                        :containMrdm="item.options.containMrdm"
                        :rules="item.options.rules"

                        :small="sizeSmall"
                        :medium="sizeMedium"
                        :lazy="options.lazy"
                        :disabled="options.disabled || item.disabled"
                        @input="updateValue"
                    />
                    <ur-date-time-range-picker v-else-if="item.type === 'datetime-range'" 
                        :ref="'expand-'+item.value+'-'+index"
                        v-model="formData[item.value]" 
                        :init="item.options.init"
                        :minDate="item.options.minDate"
                        :maxDate="item.options.maxDate"
                        :noPlaceholder="item.options.noPlaceholder"
                        :cancelLabel="item.options.cancelLabel"
                        :confirmLabel="item.options.confirmLabel"
                        :timepickerMode="item.options.timepickerMode ? 'dropdown' : 'false'"
                        :term="item.options.term"
                        :containMrdm="item.options.containMrdm"
                        :oneInputMode="item.options.oneInputMode"
                        :rules="item.options.rules"

                        :small="sizeSmall"
                        :medium="sizeMedium"
                        :lazy="options.lazy"
                        :disabled="options.disabled || item.disabled"
                        @input="updateValue"
                    />
                </ur-form-item>
                
            </template>
            <template #outer-action-bar v-if="options.actionButtonLabel">
                <ur-action-bar>
                    <ur-button main @click="formSubmit">{{options.actionButtonLabel}}</ur-button>
                </ur-action-bar>
            </template>
        </ur-form-box>
        
    </div>
    
</template>

<script>
// 'ur-form'은 'ur-form-box', 'ur-form-item'을 사용하여 각종 입력 항목들의 집합인 폼을 구성하는데 사용됩니다.
// #'ur-form' is used to construct a form that is a set of various input items by using 'ur-form-box' and 'ur-form-item'.

export default {
    name: 'ur-form',
    props: {
        // $ver: v1.0.1
        // v-model로 바인딩 되는 객체입니다. <br />
        // 객체에 각 항목의 'value' 값과 동일한 속성이 있어야 각 항목과 연결됩니다.
        // #Object bound to v-model. <br />
        // #Object must have an attribute equal to the 'value' property of each item to be associated with each item.
        value: { type: Object },

        // $ver: v1.0.1
        // 폼 전체에 반영되는 옵션입니다. <br />
        // ㆍcolumn : 폼 항목의 열 갯수 (숫자) <br />
        // ㆍlabelWidth : 항목 라벨의 Width (숫자, px 단위) <br />
        // ㆍlabelPosition : 항목 라벨의 위치 (top, left 문자열) <br />
        // ㆍlabelAlign : 항목 라벨의 정렬 (left, right 문자열) <br />
        // ㆍexpandLabel : 폼 확장영역 토글 버튼 라벨 (문자열) <br />
        // ㆍsize : 폼 항목의 크기 (small, medium 문자열) <br />
        // ㆍlazy : 자동 유효성 체크 비활성화 여부 (true/false) <br />
        // ㆍdisabled: 폼 전체 입력항목 비활성화 여부 (true/false) <br />
        // ㆍactionButtonLabel : 폼 하단 액션버튼 라벨 (문자열)
        // #This option applies to the entire form. <br />
        // #ㆍcolumn : Number of columns in form item (number) <br />
        // #ㆍlabelWidth : Item label width (number, in px) <br />
        // #ㆍlabelPosition : Item label position ('top', 'left' string) <br />
        // #ㆍlabelAlign : Alignment of item labels ('left', 'right' string) <br />
        // #ㆍexpandLabel : Form Extended Area Toggle Button Label (String) <br />
        // #ㆍsize : Form item size ('small', 'medium' string) <br />
        // #ㆍlazy : Whether to disable automatic validation (true/false) <br />
        // #ㆍdisabled: Whether to disable the entire form entry (true/false) <br />
        // #ㆍactionButtonLabel : Action button label at the bottom of the form (string)
        options: { type: Object, default:() => {
            return {
                column: 2,
                labelWidth: 120,
                labelPosition: 'left',
                labelAlign: 'left',
                size: 'medium',
                lazy: true,
                disabled: false,
                actionButtonLabel: 'Submit'
            }            
        }},

        // $ver: v1.0.1
        // 폼 항목별 속성객체 배열입니다. 속성 유형에 따라 서로 다른 options 속성을 추가로 가질 수 있습니다. <br />
        // ㆍcolSpan : 항목이 차지할 열 갯수 (숫자) <br />
        // ㆍnoHeight : 항목 높이 제어 여부 (true/false) <br />
        // ㆍlabel : 항목의 라벨 (문자열) <br />
        // ㆍvalue : 항목과 연계될 데이터 Key (문자열) <br />
        // ㆍtype : 항목의 입력 유형 (dummy, text, textfield, textarea, dropdown-single, dropdown-multi, radio, checkbox, date, week, quarter, year, date-range, datetime, datetime-range 문자열) <br />
        // ㆍorder : 항목 순번 (숫자) <br />
        // ㆍexpended : 폼 확장영역 위치 여부 (true/false) <br />
        // ㆍrequired : 필수 항목 여부 (true/false) <br />
        // ㆍdisabled : 항목 별 비활성화 여부 (true/false) <br />
        // ㆍoptions : 항목별 옵션 (유형별 컴포넌트 Props, Object)
        // #It is an array of property objects for each form item. Depending on the attribute type, you can have additional options attributes that are different. <br />
        // #ㆍcolSpan : Number of columns the item will occupy (number) <br />
        // #ㆍnoHeight : Whether to control item height (true/false) <br />
        // #ㆍlabel : Item's label (string) <br />
        // #ㆍvalue : Data Key to be associated with the item (string) <br />
        // #ㆍtype : Input type of item ('dummy', 'text', 'textfield', 'textarea', 'dropdown-single', 'dropdown-multi', 'radio', 'checkbox', 'date', 'week', 'quarter', 'year', 'date-range', 'datetime', 'datetime-range' string) <br />
        // #ㆍorder : Item sequence number (number) <br />
        // #ㆍexpended : Whether the item is in the extended area of ​​the form (true/false) <br />
        // #ㆍrequired : Required item (true/false) <br />
        // #ㆍdisabled : Whether to disable each item (true/false) <br />
        // #ㆍoptions : Item-specific options (component props by type, object)
        items: { type: Array, default:() => [] }
    },
    data() { 
        return {
            formData: {},
            test: ''
        }
    },
    watch: {
        value(newValue) {
            if (newValue) {
                Object.keys(newValue).forEach(key => {
                    this.formData[key] = newValue[key]
                })
            }
        }
    },
    computed: {
        labelSize() {
            if (this.options.labelWidth) {
                return this.options.labelWidth + 'px'
            } else {
                return '0px'
            }
        },
        labelDisplay() {
            if (this.options.labelPosition === 'left') {
                return 'inline'
            } else {
                return 'block'
            }
        },
        sizeSmall() {
            if (this.options.size === 'small') return true
            else return false
        },
        sizeMedium() {
            if (this.options.size === 'small') return false
            else return true
        },
        mainItems() {
            const items = []
            Object.assign(items, this.items)

            return items
                .filter(item => !item.expanded)
                .sort((a, b) => { return a.order - b.order })
        },
        expandedItems() {
            const items = []
            Object.assign(items, this.items)

            return items
                .filter(item => item.expanded)
                .sort((a, b) => { return a.order - b.order })
        }
    },
    created() {
        if (this.value) {
            Object.keys(this.value).forEach(key => {
                this.$set(this.formData, key, this.value[key])
            })
        } else {
            this.items.forEach(item => {
                this.$set(this.formData, item.value, '')
            })
        }
    },
    methods: {
        updateValue() {
            // $ver: v1.0.1
            // $return: Object
            // 각 항목의 값이 업데이트 될 때, 현재 폼 데이터를 반환하며 이벤트를 발생시킵니다.
            // #When the value of each item is updated, it returns the current form data and fires an event.
            this.$emit('input', this.formData)
        },

        // @vuese
        // $ver: v1.0.1
        // $return: Boolean
        // 폼 전체 항목의 유효성을 검사한 다음, 결과를 리턴합니다.
        // #Validates the entire form item, then returns the result.
        isValid() {
            let result = true
            this.mainItems.forEach((item, index) => {
                if (item.type !== 'dummy' && item.type !== 'text') {
                    if (!this.$refs['main-'+item.value+'-'+index][0].isValid()) result = false
                }
            })

            this.expandedItems.forEach((item, index) => {
                if (item.type !== 'dummy' && item.type !== 'text') {
                    if (!this.$refs['expand-'+item.value+'-'+index][0].isValid()) result = false
                }
            })

            return result
        },
        // @vuese
        // $ver: v1.0.1
        // $return: N/A
        // 폼 전체 항목의 유효성 검사결과 메시지를 초기화 합니다.
        // #clear the message as a result of validation of the entire form.
        clearValidation() {
            this.mainItems.forEach((item, index) => {
                if (item.type !== 'dummy' && item.type !== 'text') this.$refs['main-'+item.value+'-'+index][0].clearValidation()
            })
            this.expandedItems.forEach((item, index) => {
                if (item.type !== 'dummy' && item.type !== 'text') this.$refs['expand-'+item.value+'-'+index][0].clearValidation()
            })

        },
        expandToggle(isExpand) {
            // $ver: v1.0.1
            // $return: Boolean
            // 확장 영역이 토글될 때 확장영역 펼침 여부를 반환하며 이벤트를 발생시킵니다.
            // #When the extended area is toggled, returns whether the extended area is expanded and raises an event.
            this.$emit('expand', isExpand)
        },
        formSubmit() {
            // $ver: v1.0.1
            // $return: Object
            // 액션 버튼이 클릭될 때 현재 폼 데이트를 반환하며 이벤트를 발생시킵니다.
            // #When the action button is clicked, it returns the current form data and fires an event.
            this.$emit('submit', this.formData)
        }
    }
}
</script>

<style>

</style>